<footer class="footer">
  <span>Copyright {{ currentYear }} {{ appName }}</span>
  <span>v{{ appVersion }}</span>
</footer>
